import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { countSites, querySites } from '@wix/ambassador-site-list-v2-site/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { SiteListClientBase } from './SiteListClientBase';
export class SiteListClient extends HttpBaseClient(SiteListClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "querySitesImpl", querySites);
    _defineProperty(this, "countSitesImpl", countSites);
  }
}
//# sourceMappingURL=SiteListClientHttp.js.map